import { UserStoreService } from '../../services/store/UserStore/user-store.service';
import {
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output, Pipe, PipeTransform,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { ManagementService } from '../../services/management/management.service';
import { Environment, SharedService } from '../../services/store/shared-store/shared-storage.service';
import { Observable, of } from 'rxjs';
import { RolesService } from '../../services/roles/roles.service';
import { OAuthService } from 'angular-oauth2-oidc';
import {map, tap} from 'rxjs/operators';
import find from 'lodash/find';
import { ZoomService } from '../../../modules/flow/services/flowBuilder/zoom.service';
import { FlowWebSocketsService } from '../../../modules/flow/services/flowBuilder/flow-web-sockets.service';
import { FlowManagerService } from '../../../modules/flow/services/flow-manager.service';
import {FormControl} from "@angular/forms";
import {Store} from "@ngrx/store";
import {loadEntityConfig} from "../../state";

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss'],
})
export class TopBarComponent implements OnInit, DoCheck, OnDestroy {
  constructor(
    public managementService: ManagementService,
    public sharedService: SharedService,
    public rolesService: RolesService,
    private zoomService: ZoomService,
    public flowWebSocketsService: FlowWebSocketsService,
    private oauthService: OAuthService,
    public userStrorage: UserStoreService,
    private flowManagerService: FlowManagerService,
    private store: Store
  ) {}

  @Output() searchFor = new EventEmitter<string>();

  isNightMode = false;
  theme = 'light';
  selectedEntityId = '';
  selectedEntityType = 'client';
  showSearch = false;
  searchValue: string;
  clientsMap$: Observable<any>;
  globalEnvironment: Environment;
  subscription: any;
  public options = [
    { id: 'dev', name: 'Sandbox' },
    { id: 'prod', name: 'Production' },
  ];

  selectedEnv: any = this.sharedService.globalEnvironment.environment;
  isInternalAdmin: boolean;

  @ViewChild('searchInput') searchInput: ElementRef;
  @ViewChild('selectArrow') selectArrow: ElementRef;
  @ViewChild('entityId') entityNameInput: ElementRef;
  @ViewChild('autoComplete') autocomplete;
  selectedClientNameIndex: number;

  clientNameSearchInput = new FormControl();
  filteredOptions: Observable<any>;
  selectedEntityName: '';
  numberOfOptions = 0;

  ngOnInit() {
    this.getData();
    this.selectedEntityId = this.sharedService.getEntityId();
    this.selectedEnv = this.sharedService.getEnvironment();
    this.isInternalAdmin = this.rolesService.isUserInternalAdmin();

    this.clientNameSearchInput.valueChanges.subscribe(
        val => this._filter(val)
    );
  }

  private getData() {
    this.selectedEntityId = this.sharedService.getEntityId();
    this.selectedEntityType = this.sharedService.getEntityType()
      ? this.sharedService.getEntityType().toLowerCase()
      : null;
    this.selectedEnv = this.sharedService.getEnvironment();
    this.subscription = this.clientsMap$ = this.managementService.getEntities();
    const globalEnv = this.sharedService.getGlobalEnvironment();

    if (
      globalEnv &&
      this.globalEnvironment &&
      globalEnv.entityType !== this.globalEnvironment.entityType
    ) {
      const client = this.sharedService.getDefClients()[globalEnv.entityType.toLocaleLowerCase()];
      if (!client) {
        this.subscription.subscribe((clients) => {
          if (clients && clients.length) {
            this.sharedService.changeRequestEntityId(clients[0].key);
          }
        });
      }
    }

    this.setCurrentClient();
  }

  setCurrentClient() {
    this.clientsMap$.pipe(
        map(clientData => clientData.filter((data, index) => {
          if (data['key'] === this.selectedEntityId) {
            this.selectedClientNameIndex = index;
            return data['key'] === this.selectedEntityId;
          }
        })),
        tap(data => {
          if (data !== null && data.length) {
            this.selectedEntityName = data[0]['value'];
            this.clientNameSearchInput.setValue(data[0]['value']);
            this.sharedService.changeRequestEntityId(data[0]['key']);
            this.getData();
          }
        })
    ).subscribe();
  }

  _filter(value: string) {
    const filterValue = value.toLowerCase();

    this.filteredOptions = this.clientsMap$.pipe(
        map(things => things.filter(data => data['value'].toLowerCase().includes(filterValue))),
    );
    this.filteredOptions.subscribe(
        data => this.numberOfOptions = data.length
    );
  }

  onEntitySelected() {
    this.selectedEntityName = this.entityNameInput.nativeElement.value;
    this.clientsMap$.pipe(
        map(clientData => clientData.filter(data => data['value'].toLowerCase() === this.selectedEntityName.toLowerCase())),
    ).subscribe(
        (data) => {
          this.sharedService.changeRequestEntityId(data[0]['key']);
          this.forceLabelDropdowm('selectedEntityId', 'entityId');

          // TODO; We need to move the entity data into ngrx. for now the work around
          setTimeout(() => {this.store.dispatch(loadEntityConfig());}, 10)
        }
    );
  }


  resetClientNameSearch() {
    this.updateClientNameListPosition();
    this.filteredOptions = this.clientsMap$;
  }

  updateClientNameListPosition() {
    if (this.autocomplete !== undefined && this.autocomplete.panel !== undefined) {
      const matOptionHeight = 48;
      const matOptionPosition = matOptionHeight * this.selectedClientNameIndex;
      setTimeout(() => {
        this.autocomplete.panel.nativeElement.scrollTop = matOptionPosition;
        this.highlightSelectedClientOption();
      }, 0);
    }
  }

  highlightSelectedClientOption() {
    const elem = this.autocomplete.options._results[this.selectedClientNameIndex] as ElementRef;
    elem['_element'].nativeElement.classList.add('selected-client-option');
  }

  maintainOriginalObservableOrder(): number {
    return 0;
  }

  populateEntityNameInput() {
    if (this.clientNameSearchInput.value === '') {
      this.clientNameSearchInput.setValue(this.selectedEntityName);
    } else if (this.numberOfOptions < 1) {
      this.clientNameSearchInput.setValue(this.selectedEntityName);
    }
  }

  ngDoCheck(): void {
    if (
      JSON.stringify(this.globalEnvironment) !==
      JSON.stringify(this.sharedService.getGlobalEnvironment())
    ) {
      this.getData();
      this.globalEnvironment = Object.assign({}, this.sharedService.getGlobalEnvironment());
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  forceLabelDropdowm(label, value: string) {
    setTimeout(() => {
      this[label] = this.sharedService.globalEnvironment[value].toLowerCase();
    }, 0);
  }

  changeMode() {
    this.isNightMode = !this.isNightMode;
    if (this.isNightMode) {
      this.theme = 'dark';
      document.getElementsByTagName('body')[0].className = this.theme;
      document.getElementById('icon').className =
        'payd_icon navbar-brand-icon payd-icon-nav ' + this.theme;
    } else {
      this.theme = 'light';
      document.getElementsByTagName('body')[0].className = this.theme;
      document.getElementById('icon').className =
        'payd_icon navbar-brand-icon payd-icon-nav ' + this.theme;
    }
  }

  getEnvs() {
    return this.managementService.getEnv();
  }

  helpClick() {
    window.open('https://clickatell-transact.gitbook.io/project/');
  }

  logoutUrl() {
    this.oauthService.revokeTokenAndLogout().then(() => {
      localStorage.clear();
      sessionStorage.clear();
    });
  }

  getEntityValue() {
    return Object.assign(of(), this.clientsMap$).pipe(
      map((item) => {
        const activeEntityValue = find(item, { key: this.selectedEntityId });
        return activeEntityValue ? activeEntityValue.value : '';
      })
    );
  }

  onClientNameInputToggle() {
    if (
        this.selectArrow.nativeElement.style.transform === '' ||
        this.selectArrow.nativeElement.style.transform === 'rotate(0deg) translateY(2px)'
    ) {
      this.clientNameSearchInput.setValue('');
      this.setOpenSearchPanelIcon();
    } else {
      this.populateEntityNameInput();
      this.setClosedSearchPanelIcon();
    }
  }

  setOpenSearchPanelIcon() {
    this.selectArrow.nativeElement.style.transform = 'rotate(180deg) translateY(0px)';
  }

  setClosedSearchPanelIcon() {
    this.selectArrow.nativeElement.style.transform = 'rotate(0) translateY(2px)';
  }
}

@Pipe({
  name: 'AddTooltip'
})
export class AddTooltipPipe implements PipeTransform {

  transform(name: string): boolean {
    return name?.length > 50;
  }

}